export default "__VITE_ASSET__CsJPqDXB__"